import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Form } from '@unform/web';
import PropTypes from 'prop-types';

import { Spinner } from '~/components';
import { Input, Autocomplete, DateTime, Combobox } from '~/components/Form';
import { t } from '~/helpers';

export default function CreateOrUpdate({ reference, data, create }) {

  const [posto, setPosto] = useState(0);
  // const { client } = useSelector((state) => state.user.profile);
  const { loading, find, params } = useSelector(
    (state) => state.operacaovazaonaoautorizada
  );
  const initials = create ? data : { ...find, ...data };

  useEffect(() => {
    if (!loading) {
      reference.current.setData(initials);
    }
  }, [loading, initials]);

  return (
    <>
      {loading ? (
        <div style={{ height: '14rem', width: '50rem' }}>
          <Spinner loading />
        </div>
      ) : (
        <Form ref={reference} initialData={initials} >

          <Autocomplete
            disabled
            name="idposto"
            label="nomeposto"
            url="postoscomboios"
            unique="idposto"
            getValue={({ idposto }) => setPosto(idposto || 0)}
            title={t('s.menu.configuracao.posto')}
          />

          <DateTime
            disabled
            time
            name="datahorainicialmovimentacao"
            label={t('s.operacao.abastecimento.datahorainicialmovimentacao')}
          />

          <DateTime
            disabled
            time
            name="datahorafinalmovimentacao"
            label={t('s.operacao.abastecimento.datahorafinalmovimentacao')}
          />

          <Combobox
            disabled
            name="idbico"
            label="bicoprodutobico"
            url="bicos"
            unique="idbico"
            title={t('s.menu.configuracao.bico')}
            hiddens={[{ name: 'idterminal' }, { name: 'idproduto' }]}
            params={{
              wherefield: 'idposto',
              valuewherefield: posto || data.idposto,
              typewherefield: 'EQUALS',
              fieldlist:
                'idbico, idterminal, idproduto, bicoprodutobico, tipoproduto, exibemotoristaterminal',
            }}
          />

          <Input
            disabled
            name="encerranteinicialmovimentacao"
            label={t('s.operacao.abastecimento.encerranteinicialmovimentacao')}
            type="number"
          />

          <Input
            disabled
            name="encerrantefinalmovimentacao"
            label={t('s.operacao.abastecimento.encerrantefinalmovimentacao')}
            type="number"
          />

          <Input
            disabled
            name="volumemovimentacao"
            label={t('s.operacao.abastecimento.volumemovimentacao')}
            type="number"
          />


        </Form>
      )}
    </>
  );
}

CreateOrUpdate.propTypes = {
  reference: PropTypes.objectOf(PropTypes.any).isRequired,
  create: PropTypes.bool.isRequired,
  data: PropTypes.objectOf(PropTypes.any),
};

CreateOrUpdate.defaultProps = {
  data: {},
};
